import { Command } from "./types";

export const sendCommand = (command: Command<unknown>) => {
  window.ReactNativeWebView?.postMessage(JSON.stringify(command));
};
